import { zhHK } from 'date-fns/locale'
import { configuration, initialize } from 'mmfintech-backend-api'
import { registerLocale } from 'react-datepicker'
import { backendForLocalhost } from './localization/backend'

registerLocale('zh', zhHK)

initialize(import.meta.env)

const settings = {
  backendForLocalhost,
  // backendForLocalhost: 'https://portal-sandbox.thekingdombank.com',

  cookieDomain: configuration.isLocal() ? null : '.thekingdombank.com',
  customerServiceUrlForCompanies: 'mailto:team@thekingdombank.com',
  customerServiceUrlForIndividuals: 'mailto:support@thekingdombank.com',
  privacyPolicyUrl: 'https://thekingdombank.com/privacy-policy',
  termsAndConditionsUrl: 'https://thekingdombank.com/terms-and-conditions',
  FAQUrl: 'https://thekingdombankhelp.zendesk.com/hc/en-us/sections/360005852857-FAQ',
  landingPageUrl: configuration.isDevelopment()
    ? 'https://dev.thekingdombank.com'
    : configuration.isSandbox()
      ? 'https://sandbox.thekingdombank.com'
      : 'https://thekingdombank.com/',

  languages: ['en', 'zh'],

  logoAcceptType: ['jpg', 'jpeg', 'gif', 'png', 'svg'],
  logoMaxFileSize: 1024 * 1024,
  questionnaireFileTypes: ['pdf', 'jpg', 'jpeg', 'png'],
  questionnaireMaxFileSize: 1024 * 1024 * 10,
  defaultUploadInvoiceAcceptType: ['pdf', 'jpg', 'jpeg', 'png'],
  defaultUploadInvoiceMaxFileSize: 1024 * 1024,
  // TODO: change to the correct urls
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.thekingdombank.app',
  appStoreUrl: 'https://apps.apple.com/app/id6469883222',

  //Voucher
  // TODO: expose endpoint to get this config
  minVoucherAmount: 5,
  maxVoucherAmount: 5000,
  env: configuration.isDevelopment() ? 'dev' : configuration.isSandbox() ? 'sandbox' : 'prod',

  cardsUrl: `https://cards${
    configuration.isDevelopment() ? '-dev' : configuration.isSandbox() ? '-sandbox' : ''
  }.thekingdombank.com/`,
  // 'http://localhost:3001/'

  // Bot protection form metrics
  registerFormMetrics: true,
  registerFormMetricsDebug: configuration.isLocal()
}

export default settings
